<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <div class="wrapper">
        <app-header></app-header>
        <app-sidebar [page]="'hr'" [subPage]="activeSection.slug"></app-sidebar>

        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0">{{activeSection.title}}</h1>
                            <p class="mb-0">{{ activeSection.summary }}</p>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
                                <li class="breadcrumb-item active">{{ activeSection.title }}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'hr'" [activeSlug]="activeSection.slug"></app-module-menu>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#staffFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#leaveFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#payrollFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#performanceFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#expenseFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#departmentFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#designationFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#announcementFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#bankFormModal"></button>
                    <button type="button" class="d-none" data-toggle="modal" data-target="#organogramFormModal"></button>

                    <ng-container *ngIf="activeSection.slug === 'employee-profiles-kin'">
                        <div class="row">
                            <div class="modal fade" id="staffFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite(['hr.staff', 'users']) || checkService.canModify(['hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ staffEdit ? 'Edit Staff' : 'Create Staff' }}</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelStaffEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="staffForm" (ngSubmit)="saveStaff()">
                                        <div class="card-body">
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>First Name</label>
                                                    <input type="text" class="form-control" formControlName="firstName">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Last Name</label>
                                                    <input type="text" class="form-control" formControlName="lastName">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Other Name</label>
                                                <input type="text" class="form-control" formControlName="otherName">
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Personal Email</label>
                                                    <input type="email" class="form-control" formControlName="email">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Corporate Email</label>
                                                    <input type="email" class="form-control" formControlName="c_email">
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Phone</label>
                                                    <input type="text" class="form-control" formControlName="phone">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Date of Birth</label>
                                                    <input type="date" class="form-control" formControlName="dateOfBirth">
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Designation</label>
                                                    <select class="form-control" formControlName="jobTitle">
                                                        <option value="">Select designation</option>
                                                        <option *ngFor="let designation of designationList" [value]="designation.title">{{ designation.title }}</option>
                                                    </select>
                                                    <button type="button" class="btn btn-xs btn-link p-0 mt-1" *ngIf="checkService.canWrite(['hr.designation', 'hr.staff', 'users'])" (click)="showNewStaffDesignation = !showNewStaffDesignation">Add new designation</button>
                                                    <div class="input-group input-group-sm mt-2" *ngIf="showNewStaffDesignation" [formGroup]="staffDesignationForm">
                                                        <input type="text" class="form-control" formControlName="title" placeholder="New designation">
                                                        <div class="input-group-append">
                                                            <button type="button" class="btn btn-primary" (click)="createStaffDesignation()" [disabled]="processing">Create</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Department</label>
                                                    <select class="form-control" formControlName="department">
                                                        <option value="">Select department</option>
                                                        <option *ngFor="let department of departmentList" [value]="department.ref">{{ department.title }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Employment Type</label>
                                                    <input type="text" class="form-control" formControlName="employmentType">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Hire Date</label>
                                                    <input type="date" class="form-control" formControlName="hireDate">
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Primary Country</label>
                                                    <input type="text" class="form-control text-uppercase" formControlName="country" placeholder="NG">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Assigned Countries</label>
                                                    <input type="text" class="form-control text-uppercase" formControlName="countries" placeholder="NG, GH, KE">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Profile</label>
                                                <textarea class="form-control" rows="2" formControlName="profile"></textarea>
                                            </div>
                                            <div class="form-group">
                                                <label>Address</label>
                                                <textarea class="form-control" rows="2" formControlName="address"></textarea>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>ICE Name</label>
                                                    <input type="text" class="form-control" formControlName="iceName">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>ICE Phone</label>
                                                    <input type="text" class="form-control" formControlName="icePhone">
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Next of KIN</label>
                                                    <input type="text" class="form-control" formControlName="nextOfKinName">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>KIN Phone</label>
                                                    <input type="text" class="form-control" formControlName="nextOfKinPhone">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">{{ staffEdit ? 'Save Changes' : 'Create Staff' }}</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelStaffEdit()">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Employee Directory</h3>
                                        <div class="card-tools" *ngIf="checkService.canWrite(['hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#staffFormModal" (click)="cancelStaffEdit()">
                                                <i class="fas fa-plus"></i> Create Staff
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-row">
                                            <div class="form-group col-md-5">
                                                <label>Search</label>
                                                <input type="text" class="form-control" placeholder="Search by name, email, or role" [value]="directorySearch" (input)="directorySearch = $any($event.target).value">
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label>Department</label>
                                                <select class="form-control" [value]="directoryDepartmentFilter" (change)="directoryDepartmentFilter = $any($event.target).value">
                                                    <option value="">All departments</option>
                                                    <option *ngFor="let department of departmentList" [value]="department.ref">{{ department.title }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label>Designation</label>
                                                <select class="form-control" [value]="directoryRoleFilter" (change)="directoryRoleFilter = $any($event.target).value">
                                                    <option value="">All roles</option>
                                                    <option *ngFor="let designation of designationList" [value]="designation.title">{{ designation.title }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-1 d-flex align-items-end">
                                                <button type="button" class="btn btn-default btn-block" title="Clear filters" (click)="clearDirectoryFilters()">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Staff Records</h3>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Staff</th>
                                                    <th>Employee No</th>
                                                    <th>Role & Department</th>
                                                    <th>Countries</th>
                                                    <th>Admin</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="loading">
                                                    <td colspan="6">Loading staff records...</td>
                                                </tr>
                                                <tr *ngIf="!loading && filteredStaffList().length === 0">
                                                    <td colspan="6">No staff records found.</td>
                                                </tr>
                                                <tr *ngFor="let staff of filteredStaffList()">
                                                    <td>
                                                        <div class="d-flex align-items-center" style="gap: 10px; min-width: 220px;">
                                                            <img class="img-circle border" width="42" height="42" style="object-fit: cover;" [src]="staffPhotoUrl(staff)" [alt]="staffName(staff)">
                                                            <div>
                                                                <button type="button" class="btn btn-link p-0 staff-name-link" (click)="openStaffDrawer(staff)"><strong>{{ staffName(staff) }}</strong></button><br>
                                                                <small>{{ staff.phone || '-' }}</small>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{{ staff.employeeNumber || '-' }}</td>
                                                    <td>
                                                        {{ staff.jobTitle || '-' }}<br>
                                                        <small>{{ getDepartmentTitle(staff.department) }}</small><br>
                                                        <span class="badge" [ngClass]="staff.status === 'suspended' ? 'badge-warning' : 'badge-success'">{{ staff.status || 'active' }}</span>
                                                    </td>
                                                    <td>{{ (staff.countries || []).join(', ') || staff.country || '-' }}</td>
                                                    <td>
                                                        <span class="badge badge-success" *ngIf="staff.admin">Linked</span>
                                                        <span class="text-muted" *ngIf="!staff.admin">-</span>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-secondary" title="Details" (click)="openStaffDrawer(staff)">
                                                                <i class="fas fa-eye"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.staff', 'users'])" (click)="editStaff(staff)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Suspend" *ngIf="staff.status !== 'suspended' && checkService.canModify(['hr.staff', 'users'])" (click)="suspendStaff(staff)">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.staff', 'users'])" (click)="removeStaff(staff)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'payroll-tax'">
                        <div class="row">
                            <div class="modal fade" id="payrollFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite(['hr.payroll', 'hr.staff', 'users']) || checkService.canModify(['hr.payroll', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="card mb-0">
                                            <div class="card-header">
                                                <h3 class="card-title">{{ payrollEdit ? 'Edit Payroll Record' : 'Create Payroll Record' }}</h3>
                                                <div class="card-tools">
                                                    <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelPayrollEdit()"><i class="fas fa-times"></i></button>
                                                </div>
                                            </div>
                                            <form [formGroup]="payrollForm" (ngSubmit)="savePayrollRecord()">
                                                <div class="card-body">
                                                    <div class="form-row">
                                                        <div class="form-group col-md-6">
                                                            <label>Staff</label>
                                                            <select class="form-control" formControlName="staff">
                                                                <option value="">Select staff</option>
                                                                <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label>Payroll Period</label>
                                                            <input type="text" class="form-control" formControlName="periodTitle" placeholder="June 2026 Payroll">
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-6">
                                                            <label>Period Start</label>
                                                            <input type="date" class="form-control" formControlName="periodStart">
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label>Period End</label>
                                                            <input type="date" class="form-control" formControlName="periodEnd">
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-4">
                                                            <label>Gross Pay</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="grossPay">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Allowances</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="allowances">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Bonuses</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="bonuses">
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-4">
                                                            <label>PAYE Tax</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="payeTax">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Pension</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="pension">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>NHF</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="nhf">
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-4">
                                                            <label>NHIS</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="nhis">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Other Deductions</label>
                                                            <input type="number" step="0.01" class="form-control" formControlName="otherDeductions">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Status</label>
                                                            <select class="form-control" formControlName="status">
                                                                <option value="draft">Draft</option>
                                                                <option value="processed">Processed</option>
                                                                <option value="paid">Paid</option>
                                                                <option value="cancelled">Cancelled</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-6">
                                                            <label>Currency</label>
                                                            <select class="form-control" formControlName="currency">
                                                                <option *ngFor="let currency of activeCurrencies" [value]="currency.code">{{ currency.code }} - {{ currency.name }}</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label>Country</label>
                                                            <input type="text" class="form-control text-uppercase" formControlName="country">
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Notes</label>
                                                        <textarea class="form-control" rows="3" formControlName="notes"></textarea>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button type="submit" class="btn btn-primary" [disabled]="processing">{{ payrollEdit ? 'Save Payroll' : 'Create Payroll' }}</button>
                                                    <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelPayrollEdit()">Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Payroll Summary</h3>
                                        <div class="card-tools" *ngIf="checkService.canWrite(['hr.payroll', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#payrollFormModal" (click)="cancelPayrollEdit()">
                                                <i class="fas fa-plus"></i> Create Payroll
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="payroll-summary-grid">
                                            <div class="payroll-summary-card">
                                                <span class="payroll-summary-icon icon-deep"><i class="fas fa-file-invoice-dollar"></i></span>
                                                <div>
                                                    <strong>{{ payrollList.length }}</strong>
                                                    <small>Payroll records</small>
                                                </div>
                                            </div>
                                            <div class="payroll-summary-card">
                                                <span class="payroll-summary-icon icon-green"><i class="fas fa-arrow-trend-up"></i></span>
                                                <div>
                                                    <strong>{{ payrollTotal('grossPay') | number:'1.2-2' }}</strong>
                                                    <small>Gross pay</small>
                                                </div>
                                            </div>
                                            <div class="payroll-summary-card">
                                                <span class="payroll-summary-icon icon-orange"><i class="fas fa-percent"></i></span>
                                                <div>
                                                    <strong>{{ payrollTotal('totalDeductions') | number:'1.2-2' }}</strong>
                                                    <small>Deductions</small>
                                                </div>
                                            </div>
                                            <div class="payroll-summary-card">
                                                <span class="payroll-summary-icon icon-blue"><i class="fas fa-wallet"></i></span>
                                                <div>
                                                    <strong>{{ payrollTotal('netPay') | number:'1.2-2' }}</strong>
                                                    <small>Net pay</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Payroll Records</h3>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Staff</th>
                                                    <th>Period</th>
                                                    <th>Gross</th>
                                                    <th>Tax & Pension</th>
                                                    <th>Deductions</th>
                                                    <th>Net Pay</th>
                                                    <th>Status</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="payrollList.length === 0">
                                                    <td colspan="8">No payroll records found.</td>
                                                </tr>
                                                <tr *ngFor="let record of payrollList">
                                                    <td>
                                                        <strong>{{ payrollStaffName(record) || '-' }}</strong><br>
                                                        <small>{{ record.staff?.employeeNumber || '-' }}</small>
                                                    </td>
                                                    <td>
                                                        {{ record.periodTitle }}<br>
                                                        <small>{{ record.periodStart || '-' }} to {{ record.periodEnd || '-' }}</small>
                                                    </td>
                                                    <td>{{ record.currency }} {{ record.grossPay | number:'1.2-2' }}</td>
                                                    <td>
                                                        PAYE {{ record.payeTax | number:'1.2-2' }}<br>
                                                        <small>Pension {{ record.pension | number:'1.2-2' }}</small>
                                                    </td>
                                                    <td>{{ record.totalDeductions | number:'1.2-2' }}</td>
                                                    <td><strong>{{ record.currency }} {{ record.netPay | number:'1.2-2' }}</strong></td>
                                                    <td><span class="badge" [ngClass]="payrollStatusClass(record.status + '')">{{ record.status }}</span></td>
                                                    <td class="text-right">
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Process" *ngIf="record.status !== 'processed' && checkService.canModify(['hr.payroll', 'hr.staff', 'users'])" (click)="changePayrollStatus(record, 'processed')">
                                                                <i class="fas fa-cogs"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Mark Paid" *ngIf="record.status !== 'paid' && checkService.canModify(['hr.payroll', 'hr.staff', 'users'])" (click)="changePayrollStatus(record, 'paid')">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" title="Cancel" *ngIf="record.status !== 'cancelled' && checkService.canModify(['hr.payroll', 'hr.staff', 'users'])" (click)="changePayrollStatus(record, 'cancelled')">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.payroll', 'hr.staff', 'users'])" (click)="editPayrollRecord(record)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.payroll', 'hr.staff', 'users'])" (click)="removePayrollRecord(record)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'leave-management'">
                        <div class="row">
                            <div class="modal fade" id="leaveFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="isStaffOnly() || checkService.canWrite(['hr.leave', 'hr.staff', 'users']) || checkService.canModify(['hr.leave', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ leaveEdit ? 'Edit Leave Booking' : 'Book Leave' }}</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelLeaveEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="leaveForm" (ngSubmit)="saveLeave()">
                                        <div class="card-body">
                                            <div class="form-group" *ngIf="!isStaffOnly()">
                                                <label>Staff</label>
                                                <select class="form-control" formControlName="staff">
                                                    <option value="">Select staff</option>
                                                    <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Leave Type</label>
                                                <select class="form-control" formControlName="leaveType">
                                                    <option *ngFor="let type of leaveTypes" [value]="type">{{ type }}</option>
                                                </select>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Start Date</label>
                                                    <input type="date" class="form-control" formControlName="startDate">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>End Date</label>
                                                    <input type="date" class="form-control" formControlName="endDate">
                                                </div>
                                            </div>
                                            <div class="form-row" *ngIf="!isStaffOnly()">
                                                <div class="form-group col-md-6">
                                                    <label>Status</label>
                                                    <select class="form-control" formControlName="status">
                                                        <option value="pending">Pending</option>
                                                        <option value="approved">Approved</option>
                                                        <option value="rejected">Rejected</option>
                                                        <option value="cancelled">Cancelled</option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Country</label>
                                                    <input type="text" class="form-control text-uppercase" formControlName="country" placeholder="NG">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Reason</label>
                                                <textarea class="form-control" rows="3" formControlName="reason"></textarea>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">{{ leaveEdit ? 'Save Booking' : 'Create Booking' }}</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelLeaveEdit()">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Leave Summary</h3>
                                        <div class="card-tools" *ngIf="isStaffOnly() || checkService.canWrite(['hr.leave', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#leaveFormModal" (click)="cancelLeaveEdit()">
                                                <i class="fas fa-plus"></i> Book Leave
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="leave-summary">
                                            <div>
                                                <strong>{{ leaveList.length }}</strong>
                                                <span>Total bookings</span>
                                            </div>
                                            <div>
                                                <strong>{{ leaveStatusCount('pending') }}</strong>
                                                <span>Pending</span>
                                            </div>
                                            <div>
                                                <strong>{{ leaveStatusCount('approved') }}</strong>
                                                <span>Approved</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Leave Calendar</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" (click)="previousLeaveMonth()"><i class="fas fa-chevron-left"></i></button>
                                            <span class="leave-calendar-title">{{ leaveCalendarTitle() }}</span>
                                            <button type="button" class="btn btn-tool" (click)="nextLeaveMonth()"><i class="fas fa-chevron-right"></i></button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="leave-calendar">
                                            <div class="leave-calendar-head">Sun</div>
                                            <div class="leave-calendar-head">Mon</div>
                                            <div class="leave-calendar-head">Tue</div>
                                            <div class="leave-calendar-head">Wed</div>
                                            <div class="leave-calendar-head">Thu</div>
                                            <div class="leave-calendar-head">Fri</div>
                                            <div class="leave-calendar-head">Sat</div>
                                            <ng-container *ngFor="let week of leaveCalendarWeeks()">
                                                <div class="leave-day" *ngFor="let day of week" [class.leave-day-muted]="!day.inMonth">
                                                    <div class="leave-day-number">{{ day.label }}</div>
                                                    <button type="button" class="leave-pill" *ngFor="let leave of day.leaves" (click)="!isStaffOnly() && editLeave(leave)" [class.leave-pill-approved]="leave.status === 'approved'" [class.leave-pill-rejected]="leave.status === 'rejected'" [class.leave-pill-cancelled]="leave.status === 'cancelled'">
                                                        <span>{{ leaveStaffName(leave) }}</span>
                                                        <small>{{ leave.duration }}d</small>
                                                    </button>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Leave Bookings</h3>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Staff</th>
                                                    <th>Type</th>
                                                    <th>Duration</th>
                                                    <th>Status</th>
                                                    <th *ngIf="!isStaffOnly()"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="leaveList.length === 0">
                                                    <td [attr.colspan]="isStaffOnly() ? 4 : 5">No leave bookings found.</td>
                                                </tr>
                                                <tr *ngFor="let leave of leaveList">
                                                    <td>
                                                        <strong>{{ leaveStaffName(leave) || '-' }}</strong><br>
                                                        <small>{{ leave.reason || '-' }}</small>
                                                    </td>
                                                    <td>{{ leave.leaveType }}</td>
                                                    <td>
                                                        {{ leave.startDate }} to {{ leave.endDate }}<br>
                                                        <small>{{ leave.duration }} day{{ leave.duration === 1 ? '' : 's' }}</small>
                                                    </td>
                                                    <td><span class="badge" [ngClass]="leaveStatusClass(leave.status + '')">{{ leave.status }}</span></td>
                                                    <td class="text-right" *ngIf="!isStaffOnly()">
                                                        <div class="btn-group btn-group-sm">
                                                        <button type="button" class="btn btn-success" title="Approve" *ngIf="leave.status !== 'approved' && checkService.canModify(['hr.leave', 'hr.staff', 'users'])" (click)="changeLeaveStatus(leave, 'approved')">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Reject" *ngIf="leave.status !== 'rejected' && checkService.canModify(['hr.leave', 'hr.staff', 'users'])" (click)="changeLeaveStatus(leave, 'rejected')">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" title="Cancel" *ngIf="leave.status !== 'cancelled' && checkService.canModify(['hr.leave', 'hr.staff', 'users'])" (click)="changeLeaveStatus(leave, 'cancelled')">
                                                                <i class="fas fa-times"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.leave', 'hr.staff', 'users'])" (click)="editLeave(leave)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.leave', 'hr.staff', 'users'])" (click)="removeLeave(leave)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'performance-epa'">
                        <div class="row">
                            <div class="modal fade" id="performanceFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite(['hr.performance', 'hr.staff', 'users']) || checkService.canModify(['hr.performance', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ performanceEdit ? 'Edit Performance Review' : 'Create Performance Review' }}</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelPerformanceEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="performanceForm" (ngSubmit)="savePerformanceReview()">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label>Staff</label>
                                                <select class="form-control" formControlName="staff">
                                                    <option value="">Select staff</option>
                                                    <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Review Cycle</label>
                                                <input type="text" class="form-control" formControlName="cycleTitle" placeholder="Q2 EPA 2026">
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Period Start</label>
                                                    <input type="date" class="form-control" formControlName="periodStart">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Period End</label>
                                                    <input type="date" class="form-control" formControlName="periodEnd">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Goals</label>
                                                <textarea class="form-control" rows="3" formControlName="goals"></textarea>
                                            </div>
                                            <div class="form-group">
                                                <label>Self Review</label>
                                                <textarea class="form-control" rows="3" formControlName="selfReview"></textarea>
                                            </div>
                                            <div class="form-group">
                                                <label>Manager Review</label>
                                                <textarea class="form-control" rows="3" formControlName="managerReview"></textarea>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-4">
                                                    <label>Score</label>
                                                    <input type="number" min="0" max="100" step="0.1" class="form-control" formControlName="score">
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label>Rating</label>
                                                    <select class="form-control" formControlName="rating">
                                                        <option value="">Select</option>
                                                        <option value="Excellent">Excellent</option>
                                                        <option value="Good">Good</option>
                                                        <option value="Satisfactory">Satisfactory</option>
                                                        <option value="Needs Improvement">Needs Improvement</option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label>Status</label>
                                                    <select class="form-control" formControlName="status">
                                                        <option value="draft">Draft</option>
                                                        <option value="submitted">Submitted</option>
                                                        <option value="reviewed">Reviewed</option>
                                                        <option value="approved">Approved</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Country</label>
                                                <input type="text" class="form-control text-uppercase" formControlName="country" placeholder="NG">
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">{{ performanceEdit ? 'Save Review' : 'Create Review' }}</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelPerformanceEdit()">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">EPA Summary</h3>
                                        <div class="card-tools" *ngIf="checkService.canWrite(['hr.performance', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#performanceFormModal" (click)="cancelPerformanceEdit()">
                                                <i class="fas fa-plus"></i> Create Review
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="leave-summary">
                                            <div>
                                                <strong>{{ performanceList.length }}</strong>
                                                <span>Total reviews</span>
                                            </div>
                                            <div>
                                                <strong>{{ performanceStatusCount('submitted') }}</strong>
                                                <span>Submitted</span>
                                            </div>
                                            <div>
                                                <strong>{{ performanceStatusCount('reviewed') }}</strong>
                                                <span>Reviewed</span>
                                            </div>
                                            <div>
                                                <strong>{{ performanceAverageScore() }}</strong>
                                                <span>Average score</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Performance Reviews</h3>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Staff</th>
                                                    <th>Cycle</th>
                                                    <th>Score</th>
                                                    <th>Status</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="performanceList.length === 0">
                                                    <td colspan="5">No performance reviews found.</td>
                                                </tr>
                                                <tr *ngFor="let review of performanceList">
                                                    <td>
                                                        <strong>{{ performanceStaffName(review) || '-' }}</strong><br>
                                                        <small>{{ review.rating || '-' }}</small>
                                                    </td>
                                                    <td>
                                                        {{ review.cycleTitle }}<br>
                                                        <small>{{ review.periodStart || '-' }} to {{ review.periodEnd || '-' }}</small>
                                                    </td>
                                                    <td>{{ review.score || 0 }}</td>
                                                    <td><span class="badge" [ngClass]="performanceStatusClass(review.status + '')">{{ review.status }}</span></td>
                                                    <td class="text-right">
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-primary" title="Submit" *ngIf="review.status !== 'submitted' && checkService.canModify(['hr.performance', 'hr.staff', 'users'])" (click)="changePerformanceStatus(review, 'submitted')">
                                                                <i class="fas fa-paper-plane"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Mark Reviewed" *ngIf="review.status !== 'reviewed' && checkService.canModify(['hr.performance', 'hr.staff', 'users'])" (click)="changePerformanceStatus(review, 'reviewed')">
                                                                <i class="fas fa-clipboard-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Approve" *ngIf="review.status !== 'approved' && checkService.canModify(['hr.performance', 'hr.staff', 'users'])" (click)="changePerformanceStatus(review, 'approved')">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.performance', 'hr.staff', 'users'])" (click)="editPerformanceReview(review)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.performance', 'hr.staff', 'users'])" (click)="removePerformanceReview(review)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'expenses-approvals'">
                        <div class="row">
                            <div class="modal fade" id="expenseFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="isStaffOnly() || checkService.canWrite(['hr.expense', 'hr.staff', 'users']) || checkService.canModify(['hr.expense', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="card mb-0">
                                            <div class="card-header">
                                                <h3 class="card-title">{{ expenseEdit ? 'Edit Expense' : 'Log Expense' }}</h3>
                                                <div class="card-tools">
                                                    <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelExpenseEdit()"><i class="fas fa-times"></i></button>
                                                </div>
                                            </div>
                                            <form [formGroup]="expenseForm" (ngSubmit)="saveExpense()">
                                                <div class="card-body">
                                                    <div class="form-group" *ngIf="!isStaffOnly()">
                                                        <label>Staff</label>
                                                        <select class="form-control" formControlName="staff">
                                                            <option value="">Select staff</option>
                                                            <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-6">
                                                            <label>Expense Date</label>
                                                            <input type="date" class="form-control" formControlName="expenseDate">
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label>Category</label>
                                                            <select class="form-control" formControlName="category">
                                                                <option *ngFor="let category of expenseCategories" [value]="category">{{ category }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-8">
                                                            <label>Amount</label>
                                                            <input type="number" min="0" step="0.01" class="form-control" formControlName="amount">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Currency</label>
                                                            <select class="form-control" formControlName="currency">
                                                                <option *ngFor="let currency of activeCurrencies" [value]="currency.code">{{ currency.code }} - {{ currency.name }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Description</label>
                                                        <textarea class="form-control" rows="3" formControlName="description"></textarea>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Receipt URL</label>
                                                        <input type="text" class="form-control" formControlName="receiptUrl" placeholder="https://">
                                                    </div>
                                                    <div class="form-row" *ngIf="!isStaffOnly()">
                                                        <div class="form-group col-md-4">
                                                            <label>Status</label>
                                                            <select class="form-control" formControlName="status">
                                                                <option value="pending">Pending</option>
                                                                <option value="approved">Approved</option>
                                                                <option value="rejected">Rejected</option>
                                                                <option value="paid">Paid</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-8">
                                                            <label>Decision Note</label>
                                                            <input type="text" class="form-control" formControlName="decisionNote">
                                                        </div>
                                                    </div>
                                                    <div class="form-group" *ngIf="!isStaffOnly()">
                                                        <label>Country</label>
                                                        <input type="text" class="form-control text-uppercase" formControlName="country" placeholder="NG">
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button type="submit" class="btn btn-primary" [disabled]="processing">{{ expenseEdit ? 'Save Expense' : 'Log Expense' }}</button>
                                                    <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelExpenseEdit()">Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Expense Summary</h3>
                                        <div class="card-tools" *ngIf="isStaffOnly() || checkService.canWrite(['hr.expense', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#expenseFormModal" (click)="cancelExpenseEdit()">
                                                <i class="fas fa-plus"></i> Log Expense
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="leave-summary">
                                            <div>
                                                <strong>{{ expenseList.length }}</strong>
                                                <span>Total requests</span>
                                            </div>
                                            <div>
                                                <strong>{{ expenseStatusCount('pending') }}</strong>
                                                <span>Pending</span>
                                            </div>
                                            <div>
                                                <strong>{{ expenseStatusCount('approved') }}</strong>
                                                <span>Approved</span>
                                            </div>
                                            <div>
                                                <strong>{{ expenseTotal() | number:'1.2-2' }}</strong>
                                                <span>Total amount</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card" *ngIf="!isStaffOnly()">
                                    <div class="card-header">
                                        <h3 class="card-title">Search & Filters</h3>
                                    </div>
                                    <form [formGroup]="expenseSearchForm" (ngSubmit)="searchExpenses()">
                                        <div class="card-body">
                                            <div class="form-row">
                                                <div class="form-group col-md-3">
                                                    <label>Search</label>
                                                    <input type="text" class="form-control" formControlName="q" placeholder="Description, category, staff">
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label>Staff</label>
                                                    <select class="form-control" formControlName="staff">
                                                        <option value="">All staff</option>
                                                        <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-2">
                                                    <label>Status</label>
                                                    <select class="form-control" formControlName="status">
                                                        <option value="">All</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="approved">Approved</option>
                                                        <option value="rejected">Rejected</option>
                                                        <option value="paid">Paid</option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-2">
                                                    <label>Category</label>
                                                    <select class="form-control" formControlName="category">
                                                        <option value="">All</option>
                                                        <option *ngFor="let category of expenseCategories" [value]="category">{{ category }}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-1">
                                                    <label>From</label>
                                                    <input type="date" class="form-control" formControlName="dateFrom">
                                                </div>
                                                <div class="form-group col-md-1">
                                                    <label>To</label>
                                                    <input type="date" class="form-control" formControlName="dateTo">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing"><i class="fas fa-search"></i> Search</button>
                                            <button type="button" class="btn btn-default ml-2" (click)="resetExpenseSearch()"><i class="fas fa-times"></i> Reset</button>
                                        </div>
                                    </form>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ isStaffOnly() ? 'My Expense Requests' : 'Expense Requests' }}</h3>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th *ngIf="!isStaffOnly()">Staff</th>
                                                    <th>Date</th>
                                                    <th>Category</th>
                                                    <th>Description</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Receipt</th>
                                                    <th *ngIf="!isStaffOnly()"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="expenseList.length === 0">
                                                    <td [attr.colspan]="isStaffOnly() ? 6 : 8">No expense requests found.</td>
                                                </tr>
                                                <tr *ngFor="let expense of expenseList">
                                                    <td *ngIf="!isStaffOnly()">{{ expenseStaffName(expense) || '-' }}</td>
                                                    <td>{{ expense.expenseDate || '-' }}</td>
                                                    <td>{{ expense.category || '-' }}</td>
                                                    <td>
                                                        <strong>{{ expense.description || '-' }}</strong><br>
                                                        <small class="text-muted" *ngIf="expense.decisionNote">{{ expense.decisionNote }}</small>
                                                    </td>
                                                    <td>{{ expense.currency || 'NGN' }} {{ expense.amount | number:'1.2-2' }}</td>
                                                    <td><span class="badge" [ngClass]="expenseStatusClass(expense.status + '')">{{ expense.status || 'pending' }}</span></td>
                                                    <td>
                                                        <a *ngIf="expense.receiptUrl" [href]="expense.receiptUrl" target="_blank" rel="noopener">View</a>
                                                        <span *ngIf="!expense.receiptUrl">-</span>
                                                    </td>
                                                    <td class="text-right" *ngIf="!isStaffOnly()">
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-success" title="Approve" *ngIf="expense.status !== 'approved' && checkService.canModify(['hr.expense', 'hr.staff', 'users'])" (click)="changeExpenseStatus(expense, 'approved')">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Reject" *ngIf="expense.status !== 'rejected' && checkService.canModify(['hr.expense', 'hr.staff', 'users'])" (click)="changeExpenseStatus(expense, 'rejected')">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Mark Paid" *ngIf="expense.status !== 'paid' && checkService.canModify(['hr.expense', 'hr.staff', 'users'])" (click)="changeExpenseStatus(expense, 'paid')">
                                                                <i class="fas fa-money-check-alt"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.expense', 'hr.staff', 'users'])" (click)="editExpense(expense)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.expense', 'hr.staff', 'users'])" (click)="removeExpense(expense)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'announcements-reports'">
                        <div class="row">
                            <div class="modal fade" id="announcementFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="canManageAnnouncements()">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="card mb-0">
                                            <div class="card-header">
                                                <h3 class="card-title">{{ announcementEdit ? 'Edit Announcement' : 'Compose Announcement' }}</h3>
                                                <div class="card-tools">
                                                    <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelAnnouncementEdit()"><i class="fas fa-times"></i></button>
                                                </div>
                                            </div>
                                            <form [formGroup]="announcementForm" (ngSubmit)="saveAnnouncement()">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Title</label>
                                                        <input type="text" class="form-control" formControlName="title">
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Message</label>
                                                        <textarea class="form-control" rows="5" formControlName="body"></textarea>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="form-group col-md-4">
                                                            <label>Status</label>
                                                            <select class="form-control" formControlName="status">
                                                                <option value="published">Publish now</option>
                                                                <option value="draft">Save as draft</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Country</label>
                                                            <input type="text" class="form-control text-uppercase" formControlName="country" placeholder="Blank for all">
                                                        </div>
                                                        <div class="form-group col-md-4 d-flex align-items-end">
                                                            <div class="custom-control custom-switch mb-2">
                                                                <input type="checkbox" class="custom-control-input" id="announcementPinned" formControlName="pinned">
                                                                <label class="custom-control-label" for="announcementPinned">Pin announcement</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button type="submit" class="btn btn-primary" [disabled]="processing">{{ announcementEdit ? 'Save Announcement' : 'Publish Announcement' }}</button>
                                                    <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelAnnouncementEdit()">Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-8">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Company Announcements</h3>
                                        <div class="card-tools" *ngIf="canManageAnnouncements()">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#announcementFormModal" (click)="cancelAnnouncementEdit()">
                                                <i class="fas fa-pen"></i> Compose
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div *ngIf="announcementList.length === 0" class="text-muted">No announcements published yet.</div>

                                        <div *ngIf="announcementList.length > 0">
                                            <div class="media mb-3" *ngFor="let announcement of announcementList">
                                                <div class="mr-3">
                                                    <span class="btn btn-sm rounded-circle" [ngClass]="announcement.pinned ? 'btn-primary' : 'btn-secondary'">
                                                        <i class="fas" [ngClass]="announcement.pinned ? 'fa-thumbtack' : 'fa-bullhorn'"></i>
                                                    </span>
                                                </div>
                                                <div class="media-body border rounded p-3">
                                                    <div class="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <h4>{{ announcement.title }}</h4>
                                                            <div class="text-muted small">
                                                                {{ announcement.publishedAt || announcement.created }}
                                                                <span *ngIf="announcementAuthor(announcement)"> by {{ announcementAuthor(announcement) }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="btn-group btn-group-sm" *ngIf="canManageAnnouncements()">
                                                            <button type="button" class="btn btn-success" title="Publish" *ngIf="announcement.status !== 'published'" (click)="publishAnnouncement(announcement)">
                                                                <i class="fas fa-paper-plane"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-info" title="Modify" (click)="editAnnouncement(announcement)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" (click)="removeAnnouncement(announcement)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <p>{{ announcement.body }}</p>
                                                    <div>
                                                        <span class="badge badge-primary" *ngIf="announcement.pinned">Pinned</span>
                                                        <span class="badge" [ngClass]="announcement.status === 'published' ? 'badge-success' : 'badge-secondary'">{{ announcement.status }}</span>
                                                        <span class="badge badge-light" *ngIf="announcement.country">{{ announcement.country | uppercase }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4">
                                <div class="card" *ngIf="canViewHrReports(); else reportsRestricted">
                                    <div class="card-header">
                                        <h3 class="card-title">HR Reports</h3>
                                        <div class="card-tools">
                                            <div class="btn-group btn-group-sm">
                                                <button type="button" class="btn btn-danger" title="Export PDF" [disabled]="!hrReport" (click)="exportHrReportPdf()">
                                                    <i class="fas fa-file-pdf"></i>
                                                </button>
                                                <button type="button" class="btn btn-success" title="Export Excel" [disabled]="!hrReport" (click)="exportHrReportExcel()">
                                                    <i class="fas fa-file-excel"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <form [formGroup]="reportFilterForm" (ngSubmit)="applyReportFilter()" class="mb-3">
                                            <div class="btn-group btn-group-sm mb-2">
                                                <button type="button" class="btn" [ngClass]="reportFilterForm.value.period === 'month' ? 'btn-primary' : 'btn-default'" (click)="setReportPeriod('month')">Month</button>
                                                <button type="button" class="btn" [ngClass]="reportFilterForm.value.period === 'quarter' ? 'btn-primary' : 'btn-default'" (click)="setReportPeriod('quarter')">Quarter</button>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-5">
                                                    <label>From</label>
                                                    <input type="date" class="form-control form-control-sm" formControlName="dateFrom">
                                                </div>
                                                <div class="form-group col-md-5">
                                                    <label>To</label>
                                                    <input type="date" class="form-control form-control-sm" formControlName="dateTo">
                                                </div>
                                                <div class="form-group col-md-2 d-flex align-items-end">
                                                    <button type="submit" class="btn btn-primary btn-sm btn-block">
                                                        <i class="fas fa-filter"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="card-body border-top" *ngIf="hrReport">
                                        <p class="text-muted small mb-2">{{ hrReport.dateFrom }} to {{ hrReport.dateTo }}</p>
                                        <div class="leave-summary report-summary mb-3">
                                            <div>
                                                <strong>{{ hrReport.headcountTotal || 0 }}</strong>
                                                <span>Headcount</span>
                                            </div>
                                            <div>
                                                <strong>{{ hrReport.leaveDaysTotal || 0 }}</strong>
                                                <span>Leave days</span>
                                            </div>
                                            <div>
                                                <strong>{{ (hrReport.expenseTotal || 0) | number:'1.2-2' }}</strong>
                                                <span>Expenses</span>
                                            </div>
                                        </div>

                                        <h5>Headcount by department</h5>
                                        <div class="table-responsive">
                                            <table class="table table-sm">
                                                <tbody>
                                                    <tr *ngIf="(hrReport.headcountByDepartment || []).length === 0">
                                                        <td>No headcount data.</td>
                                                    </tr>
                                                    <tr *ngFor="let row of hrReport.headcountByDepartment">
                                                        <td>{{ row.department }}</td>
                                                        <td class="text-right">{{ row.headcount }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <h5>Leave usage</h5>
                                        <div class="table-responsive">
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Status</th>
                                                        <th class="text-right">Requests</th>
                                                        <th class="text-right">Days</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngIf="(hrReport.leaveUsage?.byStatus || []).length === 0">
                                                        <td colspan="3">No leave usage data.</td>
                                                    </tr>
                                                    <tr *ngFor="let row of hrReport.leaveUsage?.byStatus">
                                                        <td>{{ row.label }}</td>
                                                        <td class="text-right">{{ row.requests }}</td>
                                                        <td class="text-right">{{ row.days }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <h5>Expense usage</h5>
                                        <div class="table-responsive">
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Status</th>
                                                        <th class="text-right">Requests</th>
                                                        <th class="text-right">Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngIf="(hrReport.expenseUsage?.byStatus || []).length === 0">
                                                        <td colspan="3">No expense data.</td>
                                                    </tr>
                                                    <tr *ngFor="let row of hrReport.expenseUsage?.byStatus">
                                                        <td>{{ row.label }}</td>
                                                        <td class="text-right">{{ row.requests }}</td>
                                                        <td class="text-right">{{ row.amount | number:'1.2-2' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <h5>Expenses by category</h5>
                                        <div class="table-responsive">
                                            <table class="table table-sm">
                                                <tbody>
                                                    <tr *ngIf="(hrReport.expenseUsage?.byCategory || []).length === 0">
                                                        <td>No expense category data.</td>
                                                    </tr>
                                                    <tr *ngFor="let row of hrReport.expenseUsage?.byCategory">
                                                        <td>{{ row.label }}</td>
                                                        <td class="text-right">{{ row.requests }}</td>
                                                        <td class="text-right">{{ row.amount | number:'1.2-2' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="card-body" *ngIf="!hrReport">
                                        <p class="mb-0 text-muted">Loading HR report summary...</p>
                                    </div>
                                </div>
                                <ng-template #reportsRestricted>
                                    <div class="card">
                                        <div class="card-header">
                                            <h3 class="card-title">HR Reports</h3>
                                        </div>
                                        <div class="card-body">
                                            <p class="mb-0 text-muted">Reports are visible to HR, COO, and CEO roles.</p>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'departments'">
                        <div class="row">
                            <div class="modal fade" id="departmentFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite(['hr.department', 'hr.staff', 'users']) || checkService.canModify(['hr.department', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ departmentEdit ? 'Edit Department' : 'Create Department' }}</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelDepartmentEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="departmentForm" (ngSubmit)="saveDepartment()">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label>Department Name</label>
                                                <input type="text" class="form-control" formControlName="title">
                                            </div>
                                            <div class="form-group">
                                                <label>Description</label>
                                                <textarea class="form-control" rows="2" formControlName="description"></textarea>
                                            </div>
                                            <div class="form-group">
                                                <label>Country</label>
                                                <input type="text" class="form-control text-uppercase" formControlName="country">
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">{{ departmentEdit ? 'Save Department' : 'Add Department' }}</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelDepartmentEdit()">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Departments</h3>
                                        <div class="card-tools" *ngIf="checkService.canWrite(['hr.department', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#departmentFormModal" (click)="cancelDepartmentEdit()">
                                                <i class="fas fa-plus"></i> Create Department
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Country</th>
                                                    <th>Description</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="departmentList.length === 0">
                                                    <td colspan="4">No departments found.</td>
                                                </tr>
                                                <tr *ngFor="let department of departmentList">
                                                    <td>{{ department.title }}</td>
                                                    <td>{{ department.country || '-' }}</td>
                                                    <td>{{ department.description || '-' }}</td>
                                                    <td class="text-right">
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.department', 'hr.staff', 'users'])" (click)="editDepartment(department)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.department', 'hr.staff', 'users'])" (click)="removeDepartment(department)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'designations'">
                        <div class="row">
                            <div class="modal fade" id="designationFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite(['hr.designation', 'hr.staff', 'users']) || checkService.canModify(['hr.designation', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ designationEdit ? 'Edit Designation' : 'Create Designation' }}</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelDesignationEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="designationForm" (ngSubmit)="saveDesignation()">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label>Designation Name</label>
                                                <input type="text" class="form-control" formControlName="title">
                                            </div>
                                            <div class="form-group">
                                                <label>Description</label>
                                                <textarea class="form-control" rows="2" formControlName="description"></textarea>
                                            </div>
                                            <div class="form-group">
                                                <label>Country</label>
                                                <input type="text" class="form-control text-uppercase" formControlName="country">
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">{{ designationEdit ? 'Save Designation' : 'Add Designation' }}</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelDesignationEdit()">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Designations</h3>
                                        <div class="card-tools" *ngIf="checkService.canWrite(['hr.designation', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#designationFormModal" (click)="cancelDesignationEdit()">
                                                <i class="fas fa-plus"></i> Create Designation
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Country</th>
                                                    <th>Description</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="designationList.length === 0">
                                                    <td colspan="4">No designations found.</td>
                                                </tr>
                                                <tr *ngFor="let designation of designationList">
                                                    <td>{{ designation.title }}</td>
                                                    <td>{{ designation.country || '-' }}</td>
                                                    <td>{{ designation.description || '-' }}</td>
                                                    <td class="text-right">
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.designation', 'hr.staff', 'users'])" (click)="editDesignation(designation)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.designation', 'hr.staff', 'users'])" (click)="removeDesignation(designation)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'onboarding-email-setup'">
                        <div class="row">
                            <div class="col-lg-4" *ngIf="checkService.canRead(['hr.staff', 'users'])">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Select Staff</h3>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-group">
                                            <label>Staff</label>
                                            <select class="form-control" [value]="selectedOnboardingStaffRef" (change)="setOnboardingStaff($event)">
                                                <option value="">Select staff</option>
                                                <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <div class="card" *ngIf="selectedOnboardingStaff() as staff">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ staffName(staff) }} Onboarding</h3>
                                    </div>
                                    <div class="card-body">
                                        <dl class="row mb-3">
                                            <dt class="col-sm-4">Corporate Email</dt>
                                            <dd class="col-sm-8">{{ staff.c_email || '-' }}</dd>
                                            <dt class="col-sm-4">Workspace Status</dt>
                                            <dd class="col-sm-8">
                                                <span class="badge" [ngClass]="staff.workspaceEmailStatus === 'created' || staff.workspaceEmailStatus === 'exists' ? 'badge-success' : 'badge-warning'">{{ staff.workspaceEmailStatus || 'pending' }}</span>
                                                <span class="text-muted ml-2">{{ staff.workspaceEmailMessage }}</span>
                                            </dd>
                                            <dt class="col-sm-4">Admin Credential</dt>
                                            <dd class="col-sm-8">{{ staff.admin?.email || '-' }}</dd>
                                        </dl>

                                        <div class="list-group">
                                            <div class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let item of onboardingItems">
                                                <span>{{ item.label }}</span>
                                                <span class="badge" [ngClass]="onboardingDone(staff, item.key) ? 'badge-success' : 'badge-secondary'">{{ onboardingDone(staff, item.key) ? 'Done' : 'Pending' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card" *ngIf="!selectedOnboardingStaff()">
                                    <div class="card-header">
                                        <h3 class="card-title">Onboarding details</h3>
                                    </div>
                                    <div class="card-body">
                                        <p class="mb-0 text-muted">Select a staff member to view onboarding activities.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'staff-bank-accounts'">
                        <div class="row">
                            <div class="modal fade" id="bankFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite(['hr.staff', 'users']) || checkService.canModify(['hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ bankEdit ? 'Edit Bank Account' : 'Add Bank Account' }}</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelBankEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="bankForm" (ngSubmit)="saveBankAccount()">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label>Staff</label>
                                                <select class="form-control" formControlName="staff">
                                                    <option value="">Select staff</option>
                                                    <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Bank Name</label>
                                                <input type="text" class="form-control" formControlName="bankName">
                                            </div>
                                            <div class="form-group">
                                                <label>Account Name</label>
                                                <input type="text" class="form-control" formControlName="accountName">
                                            </div>
                                            <div class="form-group">
                                                <label>Account Number</label>
                                                <input type="text" class="form-control" formControlName="accountNumber">
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label>Type</label>
                                                    <input type="text" class="form-control" formControlName="accountType">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label>Currency</label>
                                                    <select class="form-control" formControlName="currency">
                                                        <option *ngFor="let currency of activeCurrencies" [value]="currency.code">{{ currency.code }} - {{ currency.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Bank Code</label>
                                                <input type="text" class="form-control" formControlName="bankCode">
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">{{ bankEdit ? 'Save Changes' : 'Add Account' }}</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal" (click)="cancelBankEdit()">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Bank Accounts</h3>
                                        <div class="card-tools" *ngIf="checkService.canWrite(['hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#bankFormModal" (click)="cancelBankEdit()">
                                                <i class="fas fa-plus"></i> Add Account
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Staff</th>
                                                    <th>Bank</th>
                                                    <th>Account Name</th>
                                                    <th>Account No</th>
                                                    <th>Currency</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="bankAccountList.length === 0">
                                                    <td colspan="6">No bank accounts found.</td>
                                                </tr>
                                                <tr *ngFor="let account of bankAccountList">
                                                        <td>{{ bankStaffName(account) || '-' }}</td>
                                                        <td>{{ account.bankName }}</td>
                                                        <td>{{ account.accountName }}</td>
                                                        <td>{{ account.accountNumber }}</td>
                                                        <td>{{ account.currency }}</td>
                                                        <td class="text-right">
                                                            <div class="btn-group btn-group-sm">
                                                                <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify(['hr.staff', 'users'])" (click)="editBankAccount(account)">
                                                                    <i class="fas fa-edit"></i>
                                                                </button>
                                                                <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify(['hr.staff', 'users'])" (click)="removeBankAccount(account)">
                                                                    <i class="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'org-chart'">
                        <div class="row">
                            <div class="modal fade" id="organogramFormModal" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canModify(['hr.organogram', 'hr.staff', 'users'])">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                <div class="card mb-0">
                                    <div class="card-header">
                                        <h3 class="card-title">Set Reporting Line</h3>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <form [formGroup]="organogramForm" (ngSubmit)="saveOrganogram()">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label>Staff</label>
                                                <select class="form-control" formControlName="staff">
                                                    <option value="">Select staff</option>
                                                    <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Designation</label>
                                                <select class="form-control" formControlName="role">
                                                    <option value="">Select designation</option>
                                                    <option *ngFor="let designation of designationList" [value]="designation.title">{{ designation.title }}</option>
                                                </select>
                                                <button type="button" class="btn btn-xs btn-link p-0 mt-1" *ngIf="checkService.canWrite(['hr.designation', 'hr.staff', 'users'])" (click)="showNewOrganogramDesignation = !showNewOrganogramDesignation">Add new designation</button>
                                                <div class="input-group input-group-sm mt-2" *ngIf="showNewOrganogramDesignation" [formGroup]="organogramDesignationForm">
                                                    <input type="text" class="form-control" formControlName="title" placeholder="New designation">
                                                    <div class="input-group-append">
                                                        <button type="button" class="btn btn-primary" (click)="createOrganogramDesignation()" [disabled]="processing">Create</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Department</label>
                                                <select class="form-control" formControlName="department">
                                                    <option value="">Select department</option>
                                                    <option *ngFor="let department of departmentList" [value]="department.ref">{{ department.title }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Direct Boss</label>
                                                <select class="form-control" formControlName="directBoss">
                                                    <option value="">No direct boss</option>
                                                    <option *ngFor="let staff of staffList" [value]="staff.ref">{{ staffName(staff) }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="submit" class="btn btn-primary" [disabled]="processing">Save Reporting Line</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title">Organogram</h3>
                                        <div class="card-tools" *ngIf="checkService.canModify(['hr.organogram', 'hr.staff', 'users'])">
                                            <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#organogramFormModal">
                                                <i class="fas fa-plus"></i> Set Reporting Line
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div *ngIf="organogramList.length === 0" class="text-muted">No organogram records found.</div>

                                        <div class="org-chart" *ngIf="organogramList.length > 0">
                                            <ul class="org-tree">
                                                <ng-container *ngFor="let root of organogramRoots()">
                                                    <ng-container *ngTemplateOutlet="orgNode; context: { $implicit: root }"></ng-container>
                                                </ng-container>
                                            </ul>
                                        </div>

                                        <ng-template #orgNode let-node>
                                            <li class="org-node">
                                                <button type="button" class="org-card org-card-button" (click)="openStaffDrawer(node.staff)">
                                                    <div class="org-avatar">{{ staffName(node.staff).slice(0, 1) }}</div>
                                                    <div class="org-card-body">
                                                        <h4>{{ staffName(node.staff) }}</h4>
                                                        <p>{{ node.role || '-' }}</p>
                                                        <span>{{ getDepartmentTitle(node.department) || '-' }}</span>
                                                    </div>
                                                    <div class="org-badge">{{ organogramChildren(node).length }}</div>
                                                </button>

                                                <ul class="org-children" *ngIf="organogramChildren(node).length > 0">
                                                    <ng-container *ngFor="let child of organogramChildren(node)">
                                                        <ng-container *ngTemplateOutlet="orgNode; context: { $implicit: child }"></ng-container>
                                                    </ng-container>
                                                </ul>
                                            </li>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug !== 'employee-profiles-kin' && activeSection.slug !== 'payroll-tax' && activeSection.slug !== 'leave-management' && activeSection.slug !== 'performance-epa' && activeSection.slug !== 'expenses-approvals' && activeSection.slug !== 'announcements-reports' && activeSection.slug !== 'onboarding-email-setup' && activeSection.slug !== 'departments' && activeSection.slug !== 'designations' && activeSection.slug !== 'staff-bank-accounts' && activeSection.slug !== 'org-chart'">
                        <div class="card">
                            <div class="card-body">
                                <p class="mb-0">This HR module is ready for its workflow screen.</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </section>
        </div>

        <div class="side-drawer-backdrop" *ngIf="selectedStaff" (click)="closeStaffDrawer()"></div>
        <aside class="side-drawer staff-drawer" [class.open]="selectedStaff" *ngIf="selectedStaff">
            <div class="side-drawer-header">
                <div class="drawer-avatar">
                    <img [src]="staffPhotoUrl(selectedStaff)" [alt]="staffName(selectedStaff)">
                </div>
                <div class="drawer-title">
                    <h3>{{ staffName(selectedStaff) }}</h3>
                    <p>{{ displayValue(selectedStaff.jobTitle) }} <span *ngIf="selectedStaffDepartment() !== '-'">&middot; {{ selectedStaffDepartment() }}</span></p>
                </div>
                <span class="drawer-status" [ngClass]="selectedStaff.status === 'suspended' ? 'status-warning' : 'status-online'">
                    <i class="fas fa-circle"></i> {{ selectedStaff.status || 'active' }}
                </span>
                <button type="button" class="drawer-close" aria-label="Close details" (click)="closeStaffDrawer()">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="drawer-tabs">
                <button type="button" [class.active]="selectedStaffTab === 'overview'" (click)="setStaffDrawerTab('overview')">Overview</button>
                <button type="button" [class.active]="selectedStaffTab === 'employment'" (click)="setStaffDrawerTab('employment')">Employment</button>
                <button type="button" [class.active]="selectedStaffTab === 'profile'" (click)="setStaffDrawerTab('profile')">Profile &amp; Address</button>
                <button type="button" *ngIf="canViewFullStaffProfile()" [class.active]="selectedStaffTab === 'ice'" (click)="setStaffDrawerTab('ice')">ICE</button>
                <button type="button" *ngIf="canViewFullStaffProfile()" [class.active]="selectedStaffTab === 'kin'" (click)="setStaffDrawerTab('kin')">Next of Kin</button>
                <button type="button" *ngIf="canViewFullStaffProfile()" [class.active]="selectedStaffTab === 'bank'" (click)="setStaffDrawerTab('bank')">Bank Info</button>
                <button type="button" *ngIf="canViewFullStaffProfile()" [class.active]="selectedStaffTab === 'documents'" (click)="setStaffDrawerTab('documents')">Documents</button>
                <button type="button" [class.active]="selectedStaffTab === 'org'" (click)="setStaffDrawerTab('org')">Org Chart</button>
                <button type="button" *ngIf="canViewFullStaffProfile()" [class.active]="selectedStaffTab === 'access'" (click)="setStaffDrawerTab('access')">Access</button>
            </div>

            <div class="side-drawer-body">
                <div class="drawer-loading" *ngIf="selectedStaffLoading">Loading staff details...</div>

                <ng-container *ngIf="!selectedStaffLoading">
                    <div class="drawer-section" *ngIf="selectedStaffTab === 'overview'">
                        <div class="drawer-grid">
                            <div class="drawer-field">
                                <span>Work Email</span>
                                <strong>{{ displayValue(selectedStaff.c_email) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Department</span>
                                <strong>{{ selectedStaffDepartment() }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Personal Email</span>
                                <strong>{{ displayValue(selectedStaff.email) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Role</span>
                                <strong>{{ displayValue(selectedStaff.jobTitle) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Phone</span>
                                <strong>{{ displayValue(selectedStaff.phone) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Manager</span>
                                <strong>{{ displayValue(selectedStaffManagerName()) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Status</span>
                                <strong>{{ selectedStaff.status || 'active' }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Join Date</span>
                                <strong>{{ displayValue(selectedStaff.hireDate) }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'employment'">
                        <div class="drawer-grid">
                            <div class="drawer-field">
                                <span>Employee No</span>
                                <strong>{{ displayValue(selectedStaff.employeeNumber) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Employment Type</span>
                                <strong>{{ displayValue(selectedStaff.employmentType) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Primary Country</span>
                                <strong>{{ displayValue(selectedStaff.country) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Assigned Countries</span>
                                <strong>{{ (selectedStaff.countries || []).join(', ') || '-' }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'profile'">
                        <div class="drawer-grid">
                            <div class="drawer-field drawer-field-wide">
                                <span>Profile</span>
                                <strong>{{ displayValue(selectedStaff.profile?.summary || selectedStaff.profile?.notes) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Date of Birth</span>
                                <strong>{{ displayValue(selectedStaff.profile?.dateOfBirth) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Gender</span>
                                <strong>{{ displayValue(selectedStaff.profile?.gender) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Nationality</span>
                                <strong>{{ displayValue(selectedStaff.profile?.nationality) }}</strong>
                            </div>
                            <div class="drawer-field drawer-field-wide">
                                <span>Address</span>
                                <strong>{{ displayValue(selectedStaff.address?.address || selectedStaff.address?.addressLine1) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>City</span>
                                <strong>{{ displayValue(selectedStaff.address?.city) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>State</span>
                                <strong>{{ displayValue(selectedStaff.address?.state) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Postal Code</span>
                                <strong>{{ displayValue(selectedStaff.address?.postalCode) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Country</span>
                                <strong>{{ displayValue(selectedStaff.address?.country) }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'ice' && canViewFullStaffProfile()">
                        <div class="drawer-grid">
                            <div class="drawer-field"><span>Name</span><strong>{{ displayValue(selectedStaff.ice?.name) }}</strong></div>
                            <div class="drawer-field"><span>Relationship</span><strong>{{ displayValue(selectedStaff.ice?.relationship) }}</strong></div>
                            <div class="drawer-field"><span>Phone</span><strong>{{ displayValue(selectedStaff.ice?.phone) }}</strong></div>
                            <div class="drawer-field"><span>Email</span><strong>{{ displayValue(selectedStaff.ice?.email) }}</strong></div>
                            <div class="drawer-field drawer-field-wide"><span>Address</span><strong>{{ displayValue(selectedStaff.ice?.address) }}</strong></div>
                        </div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'kin' && canViewFullStaffProfile()">
                        <div class="drawer-grid">
                            <div class="drawer-field"><span>Name</span><strong>{{ displayValue(selectedStaff.nextOfKin?.name) }}</strong></div>
                            <div class="drawer-field"><span>Relationship</span><strong>{{ displayValue(selectedStaff.nextOfKin?.relationship) }}</strong></div>
                            <div class="drawer-field"><span>Phone</span><strong>{{ displayValue(selectedStaff.nextOfKin?.phone) }}</strong></div>
                            <div class="drawer-field"><span>Email</span><strong>{{ displayValue(selectedStaff.nextOfKin?.email) }}</strong></div>
                            <div class="drawer-field drawer-field-wide"><span>Address</span><strong>{{ displayValue(selectedStaff.nextOfKin?.address) }}</strong></div>
                        </div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'bank' && canViewFullStaffProfile()">
                        <div class="drawer-grid" *ngIf="selectedStaff.bankAccount; else noDrawerBank">
                            <div class="drawer-field">
                                <span>Bank</span>
                                <strong>{{ displayValue(selectedStaff.bankAccount.bankName) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Account Name</span>
                                <strong>{{ displayValue(selectedStaff.bankAccount.accountName) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Account Number</span>
                                <strong>{{ displayValue(selectedStaff.bankAccount.accountNumber) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Currency</span>
                                <strong>{{ displayValue(selectedStaff.bankAccount.currency) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Account Type</span>
                                <strong>{{ displayValue(selectedStaff.bankAccount.accountType) }}</strong>
                            </div>
                            <div class="drawer-field">
                                <span>Bank Code</span>
                                <strong>{{ displayValue(selectedStaff.bankAccount.bankCode) }}</strong>
                            </div>
                        </div>
                        <ng-template #noDrawerBank>
                            <div class="drawer-empty">No bank account found.</div>
                        </ng-template>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'documents' && canViewFullStaffProfile()">
                        <div class="drawer-document-row">
                            <div>
                                <strong>Passport photograph</strong>
                                <span>{{ drawerDocumentByType('passport')?.originalName || 'No passport uploaded' }}</span>
                            </div>
                            <a class="btn btn-sm btn-outline-primary" *ngIf="documentUrl(drawerDocumentByType('passport'))" [href]="documentUrl(drawerDocumentByType('passport'))" target="_blank">View</a>
                            <label class="btn btn-sm btn-outline-primary mb-0" *ngIf="canViewFullStaffProfile()">
                                Upload <input type="file" hidden accept="image/*" (change)="uploadPassport($event, selectedStaff)">
                            </label>
                        </div>
                        <div class="drawer-document-row">
                            <div>
                                <strong>Resume</strong>
                                <span>{{ drawerDocumentByType('resume')?.originalName || 'No resume uploaded' }}</span>
                            </div>
                            <a class="btn btn-sm btn-outline-primary" *ngIf="documentUrl(drawerDocumentByType('resume'))" [href]="documentUrl(drawerDocumentByType('resume'))" target="_blank">View</a>
                            <label class="btn btn-sm btn-outline-primary mb-0" *ngIf="canViewFullStaffProfile()">
                                Upload <input type="file" hidden (change)="uploadResume($event, selectedStaff)">
                            </label>
                        </div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'org'">
                        <div class="drawer-org-card" *ngIf="selectedStaffManagerName()">
                            <span>Reports to</span>
                            <strong>{{ selectedStaffManagerName() }}</strong>
                        </div>
                        <div class="drawer-org-card active">
                            <span>Current staff</span>
                            <strong>{{ staffName(selectedStaff) }}</strong>
                        </div>
                        <div class="drawer-org-card" *ngFor="let report of selectedStaffReports()">
                            <span>Direct report</span>
                            <strong>{{ staffName(report.staff || report) }}</strong>
                        </div>
                        <div class="drawer-empty" *ngIf="!selectedStaffManagerName() && selectedStaffReports().length === 0">No reporting line has been set.</div>
                    </div>

                    <div class="drawer-section" *ngIf="selectedStaffTab === 'access' && canViewFullStaffProfile()">
                        <div class="drawer-access-card" [ngClass]="selectedStaff.admin ? 'active' : ''">
                            <i class="fas" [ngClass]="selectedStaff.admin ? 'fa-check-circle' : 'fa-info-circle'"></i>
                            <div>
                                <strong>{{ selectedStaff.admin ? 'Login active' : 'No admin login linked' }}</strong>
                                <span>{{ selectedStaff.admin?.email || selectedStaff.c_email || selectedStaff.email || '-' }}</span>
                            </div>
                        </div>
                        <div class="drawer-access-card" [ngClass]="selectedStaff.workspaceEmailStatus === 'created' ? 'active' : ''">
                            <i class="fas fa-envelope"></i>
                            <div>
                                <strong>Workspace email</strong>
                                <span>{{ selectedStaff.workspaceEmailStatus || 'pending' }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </aside>

        <app-footer></app-footer>
    </div>
</div>
